import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Usuarios from "@/components/Users/list.vue";
import CrearUsuario from "@/components/Users/create.vue";
import EditarUsuario from "@/components/Users/edit.vue";
import Estaciones from "@/components/Stations/list.vue";
import CrearEstacion from "@/components/Stations/create.vue";
import EditarEstacion from "@/components/Stations/edit.vue";
import Direcciones from "@/components/Address/list.vue";
import CrearDireccion from "@/components/Address/create.vue";
import EditarDireccion from "@/components/Address/edit.vue";
import GenerarArchivoConfiguracion from "@/components/SettingsFile/create.vue";
import TareasEstacion from "@/components/Tasks/list.vue";
import CrearTareasEstacion from "@/components/Tasks/create.vue";
import EditarTareasEstacion from "@/components/Tasks/edit.vue";
import DescargarTareas from "@/components/SettingsFile/list.vue";
import DescargarRespaldos from "@/components/BackUp/download.vue";
import AboutUs from "@/pages/AboutUs.vue";
import Notifications from "@/pages/Notifications.vue";
import Login from "@/pages/Login.vue";
import Restore from "@/pages/Restore.vue";
import Reset from "@/pages/UserProfile/ResetPassword.vue";
import auth from "../token";

let routes = [];
if (auth.getUserLogged()) {

  const at = localStorage.getItem('attributes') ? JSON.parse(localStorage.getItem('attributes')) : null;
  if(at === null) auth.logout('Permisos insuficientes, verifique con su administrador');

  routes = [
    {
      path: "/",
      component: DashboardLayout,
      meta: {
        requiresAuth: false
      },
      children: [
        {
          path: "dashboard",
          name: "Inicio",
          component: Dashboard,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "stats",
          name: "stats",
          component: UserProfile,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "usuarios",
          name: "usuarios",
          component: Usuarios,
          meta: {
            requiresAuth: at.menu_users[0] === 'true' ? true : false 
          }
        },
        {
          path: "crear-usuario",
          name: "usuario",
          component: CrearUsuario,
          meta: {
            requiresAuth: at.menu_users[0] === 'true' ? true : false 
          }
        },
        {
          path: "editar-usuario/:id",
          name: "editar usuario",
          component: EditarUsuario,
          meta: {
            
            requiresAuth: at.menu_users[0] === 'true' ? true : false 
          }
        },
        {
          path: "estaciones",
          name: "estaciones",
          component: Estaciones,
          meta: {
            requiresAuth: at.menu_stations[0] === 'true' ? true : false 
          }
        },
        {
          path: "crear-estacion",
          name: "estación",
          component: CrearEstacion,
          meta: {
            requiresAuth: at.menu_stations[0] === 'true' ? true : false 
          }
        },
        {
          path: "editar-estacion/:id",
          name: "Editar estación",
          component: EditarEstacion,
          meta: {
            requiresAuth: at.menu_stations[0] === 'true' ? true : false 
          }
        },
        {
          path: "direcciones",
          name: "direcciones",
          component: Direcciones,
          meta: {
            requiresAuth: at.menu_address[0] === 'true' ? true : false 
          }
        },
        {
          path: "crear-direccion",
          name: "Direccion",
          component: CrearDireccion,
          meta: {
            requiresAuth: at.menu_address[0] === 'true' ? true : false 
          }
        },
        {
          path: "editar-direccion/:id",
          name: "Editar dirección",
          component: EditarDireccion,
          meta: {
            requiresAuth: at.menu_address[0] === 'true' ? true : false 
          }
        },
        {
          path: "generar-archivo-configuracion",
          name: "Archivo de configuración",
          component: GenerarArchivoConfiguracion,
          meta: {
            requiresAuth: at.menu_configurations[0] === 'true' ? true : false
          }
        },
        {
          path: "tareas-estacion",
          name: "Tareas por estación",
          component: TareasEstacion,
          meta: {
            requiresAuth: at.menu_tasks[0] === 'true' ? true : false
          }
        },
        {
          path: "crear-tareas-estacion",
          name: "Tarea",
          component: CrearTareasEstacion,
          meta: {
            requiresAuth: at.menu_tasks[0] === 'true' ? true : false
          }
        },
        {
          path: "editar-tareas-estacion/:id",
          name: "Editar tarea",
          component: EditarTareasEstacion,
          meta: {
            requiresAuth: at.menu_tasks[0] === 'true' ? true : false
          }
        },
        {
          path: "descargar-tareas",
          name: "Configuración",
          component: DescargarTareas,
          meta: {
            requiresAuth: at.menu_configurations[0] === 'true' ? true : false
          }
        },
        {
          path: "descargar-respaldo",
          name: "Descarga archivos respaldados",
          component: DescargarRespaldos,
          meta: {
            requiresAuth: at.menu_backups[0] === 'true' ? true : false
          }
        },
        {
          path: "notifications",
          name: "notifications",
          component: Notifications,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "reset",
          name: "Cambiar contraseña",
          component: Reset,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "about-us",
          name: "Acerca de",
          component: AboutUs,
          meta: {
            requiresAuth: false
          }
        }
      ],
    },
    { path: "*", component: NotFound },
    { path: "/login", component: Login }
  ];
} else {
  routes = [
    { path: "*", redirect: { path: '/' } },
    { path: "/", component: Login },
    { path: "/login", component: Login },
    { path: "/restore", component: Restore }
  ]
}

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
